<script lang="ts">
    import type {AxiosInstance} from 'axios';
    import {TEMPLATE} from 'general/constants';
    import {dyData, modal} from 'general/store';

    import s from './style.module.css';

    export let instance: AxiosInstance;
    export let instanceDY: AxiosInstance;

    const OPTIONS = {
        [TEMPLATE.CIRCLE]: () => import('desktop/templates/circleModal/CircleModal.svelte'),
        [TEMPLATE.SQUARE]: () => import('desktop/templates/squareModal/SquareModal.svelte'),
        [TEMPLATE.SQUARE_PRODUCT]: () =>
            import('desktop/templates/squareProductModal/SquareProductModal.svelte'),
        [TEMPLATE.SQUARE_EXIT]: () =>
            import('desktop/templates/squareExitModal/SquareExitModal.svelte'),
        [TEMPLATE.SQUARE_EXIT_CART]: () =>
            import('desktop/templates/squareExitCartModal/SquareExitModal.svelte'),
        [TEMPLATE.EXP_SQUARE]: () =>
            import('desktop/templates/expSquareModal/ExpSquareModal.svelte'),
        [TEMPLATE.SQUARE_ADA_EXIT]: () =>
            import('desktop/templates/squareAdaExitModal/SquareAdaExitModal.svelte'),
        [TEMPLATE.SQUARE_EXIT_RECOMMENDATIONS]: () =>
            import('desktop/templates/squareExitRecommendations/SquareExitRecommendations.svelte'),
        [TEMPLATE.SQUARE_DESKTOP_COMMON]: () =>
            import('desktop/templates/squareCommonModal/SquareCommonModal.svelte'),
        [TEMPLATE.SQUARE_EXIT_REDESIGN]: () =>
            import('desktop/templates/squareExitModalRedesign/SquareExitModalRedesign.svelte'),
    } as const;

    $: componentPromise = OPTIONS[$dyData.template] ? OPTIONS[$dyData.template]() : null;

    const handleKeydown = (event: KeyboardEvent) => {
        if (event.key === 'Escape') {
            event.preventDefault();
            modal.close();
        }
    };
</script>

<svelte:window on:keydown={handleKeydown} />

<div class={s.popup}>
    {#if componentPromise}
        {#await componentPromise then module}
            <svelte:component this={module.default} {instance} {instanceDY} />
        {/await}
    {/if}
</div>
